import { Injectable } from '@angular/core';
import { NetworkManager } from 'src/app/managers/network/network.manager';
import { HttpHeaders } from '@angular/common/http';
import { RequestField } from 'src/app/enums/network/request/requestField.enum';
import { CQWebappApi } from 'src/app/enums/network/request/cqwebapp/cqwebappApi.enum';

@Injectable({
  providedIn: 'root',
})
export class SiteRequest {
  constructor(private network: NetworkManager) {}

  /**
   *
   * @param token
   * @param organizationId
   */
  list(token: string, organizationId: number, enabled: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SITE_LIST;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, organizationId.toString());
    form.set(RequestField.ENABLED, enabled.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param organizationId
   */
  detail(token: string, siteId: number) {
    let url = this.network.CodaQApi() + CQWebappApi.SITE_DETAIL;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param orgId
   * @param data
   */
  create(token: string, orgId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SITE_CREATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, orgId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  /**
   *
   * @param token
   * @param siteId
   * @param data
   */
  update(token: string, siteId: number, data: string) {
    let url = this.network.CodaQApi() + CQWebappApi.SITE_UPDATE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.SITE_ID, siteId.toString());
    form.set(RequestField.DATA, data.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }

  listByServiceCode(
    token: string,
    orgId: number,
    serviceId: number,
    serviceCode: string,
    enabled: number,
  ) {
    let url = this.network.CodaQApi() + CQWebappApi.SITE_LIST_BY_SERVICE;

    const headers = new HttpHeaders().append(RequestField.TOKEN, token);

    const form = new URLSearchParams();
    form.set(RequestField.ORGANIZATION_ID, orgId.toString());
    form.set(RequestField.SERVICE_ID, serviceId.toString());
    form.set(RequestField.SERVICE_CODE, serviceCode.toString());
    form.set(RequestField.ENABLED, enabled.toString());

    return this.network.http().put(url, form.toString(), { headers });
  }
}
